import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

import {
  ActivateDeactivateCommands,
  IsActiveProperty,
  Feature,
  FeaturePropertyKey,
  FeatureCommands,
  DeviceIds,
} from '@vi-iot/client';

import { GTMService } from '@services';
import { InstallationFeaturesStore } from '@store';
import { PillType } from '../../../../../shared/components/pill/pill.model';

@Component({
  selector: 'app-hems-activate-deactivate-setting-option',
  templateUrl: './hems-activate-deactivate-setting-option.component.html',
  styleUrls: ['./hems-activate-deactivate-setting-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HemsActivateDeactivateSettingOptionComponent {
  readonly pillType = PillType;
  readonly featurePropertyKey = FeaturePropertyKey;
  readonly featureCommands = FeatureCommands;

  @Input() feature: Feature<IsActiveProperty, ActivateDeactivateCommands>;
  @Input() isBetaFeature = false;
  @Input() title: string;
  @Input() gtmAction: string;
  @Input() infoText: string;
  @Input() hemsGateway: string;

  constructor(
    protected installationFeaturesStore: InstallationFeaturesStore,
    private gtmService: GTMService
  ) {}

  hemsSettingChange(
    change: MatSlideToggleChange,
    feature: Feature<IsActiveProperty, ActivateDeactivateCommands>
  ): void {
    this.installationFeaturesStore.updateFeature(
      feature.feature,
      {},
      FeaturePropertyKey.active,
      null,
      change.checked ? FeatureCommands.activate : FeatureCommands.deactivate,
      this.hemsGateway,
      DeviceIds.Hems
    );
    this.gtmService.track(change.checked ? 'onActivate' : 'onDeactivate', this.gtmAction, 'hems');
  }
}
